import { AuthScreen, OTPMethod, RegisterDataType } from './reducer';

export enum AuthActionType {
  SET_AUTH_SCREEN = `SET_AUTH_SCREEN`,
  SET_REGISTER_DATA = `SET_REGISTER_DATA`,
  SET_OTP_METHOD = `SET_OTP_METHOD`,
}

export interface AuthSetAuthScreenAction {
  type: AuthActionType.SET_AUTH_SCREEN;
  payload: {
    authScreen: AuthScreen;
  };
}

export interface AuthSetRegisterDataAction {
  type: AuthActionType.SET_REGISTER_DATA;
  payload: {
    registerData: RegisterDataType;
  };
}

export interface AuthSetOTPMethodAction {
  type: AuthActionType.SET_OTP_METHOD;
  payload: {
    otpMethod: OTPMethod;
  };
}

export type AuthActions = AuthSetAuthScreenAction | AuthSetRegisterDataAction | AuthSetOTPMethodAction;
